import { useContext } from 'react'
import { Link } from 'react-router-dom'
import { CollectionContext } from '../../state/CollectionContext'
import { Toggle } from './Toggle'
import globalStyle from '../../styles/common.module.css'
import style from './story.module.css'


// ~~~~~~~~~~~~~~~~~~~~ STORY ~~~~~~~~~~~~~~~~~~~~
export function Nav() {
  const context = useContext(CollectionContext)
  const storyIndex = context.state.findIndex((story) => story.isActive)
  if (storyIndex === -1) return null
  const story = context.state[storyIndex]
  if (!story) return null

  const isLastStory = storyIndex === context.state.length - 1

  return (
    <div className={style.navigation}>
      {story.mode === 'edit' ? (
        <button
          className={[globalStyle.button, globalStyle.buttonSM, globalStyle.right].join(' ')}
          onClick={() => {
            window.scrollTo(0, 0)
            context.dispatch({ type: 'set_mode', mode: 'review' })
          }}
        >
          Review edits
        </button>
      ) : (
        <>
          <div>
            <button
              className={[
                globalStyle.button,
                globalStyle.buttonSM,
                globalStyle.light,
                globalStyle.left,
              ].join(' ')}
              onClick={() => {
                window.scrollTo(0, 0)
                if(story.mode === 'video') {
                  context.dispatch({ type: 'set_mode', mode: 'review' })
                } else {
                  context.dispatch({ type: 'set_mode', mode: 'edit' })
                }
              }}
            >
              Back
            </button>
          </div>
          <div className={style.navigationRight}>
            {
              (story.mode === 'review' || story.mode === 'final') && 
              <div className={style.toggleWrapper}>
                <p className={globalStyle.buttonSM}>
                  {`${story.mode === 'final' ? 'Hide' : 'Show'} LP edits`}
                </p>
                <Toggle
                  option1={'Draft mode'}
                  option2={'Edited mode'}
                  changeHandler={(newState: string) => {
                    window.scrollTo(0, 0)
                    newState === 'Draft mode'
                      ? context.dispatch({ type: 'set_mode', mode: 'review' })
                      : context.dispatch({ type: 'set_mode', mode: 'final' })
                  }}
                />
            </div>
            }
            {isLastStory ? (
              <Link
                to={`/takeaways`}
                className={[
                  globalStyle.button,
                  globalStyle.buttonSM,
                  globalStyle.light,
                  globalStyle.right,
                ].join(' ')}
              >
                Next
              </Link>
            ) : (
              <button
                className={[
                  globalStyle.button,
                  globalStyle.buttonSM,
                  globalStyle.light,
                  globalStyle.right,
                ].join(' ')}
                onClick={() => {
                  window.scrollTo(0, 0)
                  if(story.videos?.length && story.mode !== 'video') {
                    context.dispatch({ type: 'set_mode', mode: 'video' })
                  } else {
                    context.dispatch({ type: 'next_story' })
                  }
                }}
              >
                Next
              </button>
            )}
          </div>
        </>
      )}
    </div>
  )
}


